export default class URLParser {

    constructor(aProtocol,aHost,aPathname,aSearch) {

        this.protocol = aProtocol;
        this.host = aHost;
        this.pathname = aPathname;
        this.search = aSearch;
        
        this.params = this.parseArguments();
        
    }
    
    static hrefToLocation(aHREF){
        let l = document.createElement("a");
        l.href = aHREF;
        return l;
    }
    
    /**
     * Source : https://stackoverflow.com/questions/2090551/parse-query-string-in-javascript#13896633
     * @returns {{}}
     */
    parseArguments() {
        if (typeof this.search != "string" || this.search.length == 0) return {};
        let s = this.search.substring(1).split("&");
        let s_length = s.length;
        let bit, query = {}, first, second;
        for (let i = 0; i < s_length; i++) {
            bit = s[i].split("=");
            first = decodeURIComponent(bit[0]);
            if (first.length == 0) continue;
            second = decodeURIComponent(bit[1]);
            if (typeof query[first] == "undefined") query[first] = second;
            else if (query[first] instanceof Array) query[first].push(second);
            else query[first] = [query[first], second];
        }
        return query;
    }
    
    addParam(aKey, aValue){
        this.params[aKey] = aValue;
    }
    
    getParam(aKey){
        return this.params[aKey];
    }

    getCleanURL(aWithDomain=true) {
        return ( aWithDomain ? this.protocol + '//' + this.host : '' ) + this.pathname;
    }
    
    getFullURL(aWithDomain=true){
        return this.getCleanURL(aWithDomain) + this.getParamString();
    }
    
    getParamString(){
		let params = $.param(this.params);
		return params.length>0 ? '?'+params : '';
	}

    hasIndex() {
        return this.pathname.indexOf('index.php') > -1;
    }
    
    hasPageId(){
        return this.params['id'] !== undefined;
    }
    
    hasLanguage(){
        return this.params['L'] !== undefined;
    }
    
    getLanguage(){
        return this.params['L'];
    }
    
    isRealURL(){
        return !this.hasIndex() || !this.hasPageId();
    }
    
    getUrlWithTarget(aTarget){
        return (!this.isRealURL() ? '/' : this.getCleanURL() ) + aTarget;
    }
    
    getUrlForAPI(){
        return this.getUrlWithTarget('api.json');
    }

}
